<template>
    <div>
        <div class="header-box mb-4">
            <div class="container">
                <div class="py-4">
                    <slot name="header"></slot>
                </div>
            </div>
        </div>
        <div class="container mb-4">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>

<style>

</style>
